export default "__VITE_ASSET__Cgef7Rh5__"